import type * as Immutable from 'immutable';
import { createMigration } from './utils';

const TEXT_ASSET_CLASS_TYPES = ['CanvasTextAsset', 'CanvasCaptionAsset', 'CanvasFancyCaptionAsset'];

function migrateSceneGroup(sceneGroup: Immutable.Map<string, unknown>) {
    return sceneGroup.withMutations((map) => {
        const captionAsset = map.getIn(['captions', 'asset']) as
            | Immutable.Map<string, unknown>
            | undefined;
        if (!captionAsset) {
            return;
        }

        const classType = captionAsset.get('classType') as string;

        // Remove dynamic styling properties from caption assets
        if (TEXT_ASSET_CLASS_TYPES.includes(classType)) {
            const basePath = ['captions', 'asset'];
            if (captionAsset.has('objectAnimation')) {
                map.removeIn([...basePath, 'objectAnimation']);
            }
            if (captionAsset.has('colorGraphics')) {
                map.removeIn([...basePath, 'colorGraphics']);
            }
            if (captionAsset.has('alphaGraphics')) {
                map.removeIn([...basePath, 'alphaGraphics']);
            }
        }
    });
}

export const migrationTo9_226 = createMigration({
    migrateVideo(video) {
        return video.withMutations((map) => {
            map.get('sceneGroups', []).forEach(
                (sceneGroup: Immutable.Map<string, unknown>, i: number) => {
                    map.setIn(['sceneGroups', i], migrateSceneGroup(sceneGroup));
                },
            );
            map.get('slides').forEach((scene: Immutable.Map<string, unknown>, i: number) => {
                map.setIn(['slides', i], this.migrateScene(scene));
            });
        });
    },
    migrateScene(scene) {
        return scene.withMutations((map) => {
            map.get('children', []).forEach((_child: unknown, cIndex: number) => {
                const path = ['children', cIndex];
                const asset = map.getIn(path) as Immutable.Map<string, unknown> | undefined;
                if (!asset) {
                    return;
                }

                const classType = asset.get('classType') as string;

                // Remove dynamic styling properties from TextAssets and ColorAssets
                if (TEXT_ASSET_CLASS_TYPES.includes(classType) || classType === 'ColorAsset') {
                    // Remove the properties if they exist directly on the asset
                    if (asset.has('objectAnimation')) {
                        map.removeIn([...path, 'objectAnimation']);
                    }
                    if (asset.has('colorGraphics')) {
                        map.removeIn([...path, 'colorGraphics']);
                    }
                    if (asset.has('alphaGraphics')) {
                        map.removeIn([...path, 'alphaGraphics']);
                    }
                }
            });
        });
    },
});
